import React from "react";
import PdfCanvasPreview from "../components/PdfCanvasPreview";

export default function ExamPreview({ url, loading, error, generating, onRetry, onModify, onGenerate, enhancedFlow = false, tiers = [], selectedTier = "", onTierChange, generationFailure, onGenerationAction }) {
  return (
    <section className="ql-exam-card ql-final-preview">
      <div className="ql-exam-card-heading">
        <span className="ql-teacher-eyebrow">Étape 4</span>
        <h2>Prévisualisation fidèle de l’épreuve</h2>
        <p>Ce PDF est produit par le même moteur ReportLab que le document final. Aucune épreuve n’est encore créée.</p>
        <div className="ql-preview-security" role="note">
          <i className="bi bi-shield-lock-fill" aria-hidden="true" />
          <span>La prévisualisation comporte volontairement plusieurs filigranes de sécurité. Après paiement, vous pourrez télécharger l’épreuve définitive, propre et sans ces filigranes.</span>
        </div>
      </div>
      {loading && <div className="ql-exam-inline-state" role="status"><span className="spinner-border spinner-border-sm" /> Préparation de toutes les pages…</div>}
      {error && <div className="ql-exam-inline-state error" role="alert"><span>{error}</span><button type="button" onClick={onRetry}>Réessayer</button></div>}
      {url && <PdfCanvasPreview title="Prévisualisation PDF de l’épreuve" url={url} className="ql-final-preview-frame" />}
      {enhancedFlow && url && (
        <fieldset className="ql-exam-tier-field ql-preview-tier-field">
          <legend>Choisissez le palier après avoir vérifié l’épreuve *</legend>
          <div className="ql-exam-tier-options">
            {tiers.map((item) => (
              <label key={item.code} className={selectedTier === item.code ? "selected" : ""}>
                <input id={`exam-preview-tier-${item.code}`} type="radio" name="exam-preview-tier" value={item.code} checked={selectedTier === item.code} onChange={(event) => onTierChange(event.target.value)} />
                <span><strong>{item.label || item.code} — {item.amount} {item.currency || "FCFA"}</strong><small>{item.code === "PREMIUM" ? "PDF sujet, DOCX et PDF corrigé" : "PDF sujet"}</small></span>
              </label>
            ))}
          </div>
        </fieldset>
      )}
      {enhancedFlow && generationFailure && (
        <div className="ql-generation-failure" role="alert">
          <strong>La génération n’a pas abouti</strong>
          <p>{generationFailure.message}</p>
          {generationFailure.diagnosticReference && <p>Référence de diagnostic : <code>{generationFailure.diagnosticReference}</code></p>}
          <button type="button" className="btn btn-outline-primary" onClick={onGenerationAction}>{generationFailure.actionLabel}</button>
        </div>
      )}
      <div className="ql-final-preview-actions">
        <button type="button" className="btn btn-outline-secondary" onClick={onModify} disabled={generating}>Modifier</button>
        <button type="button" className="btn btn-primary" onClick={onGenerate} disabled={!url || loading || generating}>{generating ? "Génération…" : "Générer l’épreuve"}</button>
      </div>
    </section>
  );
}
